const validate = (values, props = {}) => {
	const errors = {};
    const memberErrors = {};

    // Only validate name if it should be visible
    if (props.isCompany && !props.factoBusinessAssociation) {
        if (!values.name) {
            errors.name = 'Este campo es obligatorio';
        }
    }

    if (!values.cuil) {
        errors.cuil = 'Este campo es obligatorio';
    }
    if (values.cuil &&
        (!/(\d{11})$/.test(values.cuil) || !/(2\d{10})$/.test(values.cuil))) {
            errors.cuil = 'El cuil no es válido'
    }

	return errors;
  };

  export default validate;


/** WEBPACK FOOTER **
 ** ./src/components/Validations/submitSuretyForm.js
 **/